import React from 'react';
import ProfilePostList from './ProfilePostList';

function MyQuiz() {
    return (
        <ProfilePostList endpoint={"my-quiz"}/>
    );
}

export default MyQuiz;